export default "b218d8129e05ab48.png"